export const HAS_OPENED_WIDGET_OR_DISMISSED_TOOLTIP_KEY = 'hubspot:helpInTheNav:userHasOpenedHelpWidget';